export const WHATSAPP_NUMBER = "919686454696";
export const WHATSAPP_DISPLAY = "+91 96864 54696";

export const buildWhatsAppLink = (text) => {
  const encoded = encodeURIComponent(text || "Hello Believers Common, I'd like to know more.");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
};

export const SOCIALS = [
  { label: "Instagram", href: "#", abbr: "IG" },
  { label: "LinkedIn", href: "#", abbr: "LI" },
  { label: "YouTube", href: "#", abbr: "YT" },
  { label: "WhatsApp", href: `https://wa.me/${WHATSAPP_NUMBER}`, abbr: "WA" },
  { label: "X / Twitter", href: "#", abbr: "X" },
];
